// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__TC_aA","noMargin":"IconButton_noMargin__g1uP5"};